<template>
  <div class="selectCity">
    <div class="gridBox">
      <van-grid column-num="2">
        <van-grid-item>
          <div class="item">
            <div class="title requiredColum">省</div>
            <van-cell is-link @click="showPopup('省')">{{
              province || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="item">
            <div class="title requiredColum">市</div>
            <van-cell is-link @click="showPopup('市')">{{
              city || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
      </van-grid>
      <van-popup
        v-model="show"
        round
        position="bottom"
        :style="{ height: '50%' }"
      >
        <van-picker
          :title="showTitle"
          show-toolbar
          :value-key="showValue"
          :columns="columns"
          @confirm="onConfirm"
          @cancel="onCancel"
          @change="onChange"
        />
      </van-popup>
    </div>
    <div class="btnBox">
        <van-button type="info" @click="handleClick">确认</van-button>
    </div>
  </div>
</template>

<script>
export default {
    beforeDestroy () {
        this.$bus.$off("selectCity",()=>{})
    },
  created() {
    this.getProvince();
  },
  data() {
    return {
      columns: [],
      show: false,
      showValue: "",
      showTitle: "",
      province: "",
      city: "",
      provinceList: [],
      cityList: [],
    };
  },
  methods: {
    showPopup(val) {
      this.showTitle = val;
      this.show = true;
      if (val == "省") {
        this.columns = this.provinceList;
        this.showValue = "province";
      }
      if (val == "市") {
        this.columns = this.cityList;
        this.showValue = "city";
      }
    },
    onConfirm(obj) {
      if (!obj) {
        this.show = false;
        return;
      }
      if (this.showTitle == "省") {
        this.province = obj.province;
        this.getCity(obj.provinceId);
        this.columns = [];
        this.city = "";
      }
      if (this.showTitle == "市") {
        this.city = obj.city;
      }
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    onChange() {},
    getProvince() {
      this.$api
        .post("/payment/center/province/provinceList", {
          reqData: {},
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.provinceList = res.repData;
          }
        });
    },
    getCity(id) {
      this.$api
        .post("/payment/center/province/queryCities", {
          reqData: {
            provincesId: id,
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.cityList = res.repData;
          }
        });
    },
    handleClick(){
        this.$bus.$emit("selectCity",this.$route.query.type,this.city)
        this.$router.go(-1)
    },
  },
};
</script>

<style lang="scss">
.selectCity{
    height: 100%;
    display: flex;
    flex-direction: column;
}
.gridBox {
    flex: 1;
  .van-grid-item {
    width: 50% !important;
    overflow: hidden;
    position: static !important;
  }
  // background: #fff;
  .tabContro {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    font-size: 14px;
    background: #fff;
    .tit {
      color: rgb(109, 113, 132);
    }
    .del {
      color: red;
    }
  }
  .title {
    font-size: 14px;
    color: rgb(109, 113, 132);
    margin-bottom: 4px;
  }
  .van-cell {
    padding: 0 0 !important;
  }
  .van-field__control::placeholder {
    color: rgb(155, 159, 171) !important;
  }
  .item {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    .van-cell {
      padding: 0 0 !important;
    }
    .van-cell__value--alone {
      color: rgb(155, 159, 171);
      overflow: hidden !important;
      white-space: nowrap !important;
      text-overflow: ellipsis !important;
    }
  }
}
.btnBox{
    width: 100%;
    button{
        width: 100%;
    }
}
</style>